// Generated by tools/linea.ts; do not edit: change the tool and re-run it (tools/linea.test.ts
// compares the committed files to what the tool would write). The drawn Italian deck
// (docs/design/card-packs.md §5): forty SVG faces and a back under web/public/shared/cards/linea/.
import type { CardPack } from '../packs.ts';

export const LINEA_PACK = {
  name: 'linea',
  label: 'Linea',
  back: { kind: 'svg', url: '../../shared/cards/linea/back.svg', aspect: 100 / 193, colour: '#faf5e8' },
  decks: {
    italian40: {
      kind: 'files',
      dir: '../../shared/cards/linea/italian40',
      ext: 'svg',
      widths: [0],
      ids: ['AC', '2C', '3C', '4C', '5C', '6C', '7C', 'FC', 'CC', 'RC', 'AD', '2D', '3D', '4D', '5D', '6D', '7D', 'FD', 'CD', 'RD', 'AS', '2S', '3S', '4S', '5S', '6S', '7S', 'FS', 'CS', 'RS', 'AB', '2B', '3B', '4B', '5B', '6B', '7B', 'FB', 'CB', 'RB'],
      aspect: 100 / 193,
      inset: 0,
      indices: 'printed',
    },
  },
  attribution: null,
} as const satisfies CardPack;
